import { baseSchema, Update } from './base'
import { rootCommentSchema } from './comment'
import { generate } from './generate'
import { z } from 'zod'

export const timeSeriesRangeSchema = z.enum([
  'day',
  'week',
  'month',
  'year',
  'allTime',
])
export const RangeEnum = timeSeriesRangeSchema.enum
export type TimeSeriesRange = z.infer<typeof timeSeriesRangeSchema>

const commitsFiltersSchema = z
  .object({
    range: z
      .object({
        from: z.string(),
        to: z.string(),
      })
      .nullish(),
    members: z.array(z.string()).nullish(),
  })
  .optional()

export const userPreferencesSchema = baseSchema.extend({
  //  userId will be the entity id
  favoriteBlocks: z.array(z.string()),
  propertiesPanelMode: z.enum(['properties', 'history']).default('properties'),
  historyPanelFilters: commitsFiltersSchema,
  commitsFilters: commitsFiltersSchema,
  collapsePropertiesPanel: z.boolean(),
  collapseDocumentPanel: z.boolean().optional().default(false),
  collapsibleGroups: z.record(z.boolean()).default({}),
  editMode: z.boolean().optional().default(false),
  hideOnboardingGuides: z.boolean().optional().default(false),
  listSelectedView: z
    .record(z.string() /* list block id */, z.string() /* list view id */)
    .optional()
    .default({}),
  eventSelectedRange: z
    .record(z.string() /* event block id */, timeSeriesRangeSchema)
    .optional()
    .default({}),
  commentsRead: z
    .record(z.string() /* comment id */, z.string() /* timestamp */)
    .optional()
    .default({}),
  selectedThreads: z
    .record(
      z.string() /* block id */,
      z.array(
        rootCommentSchema.pick({
          branchId: true,
          blockId: true,
          // type: true,
          id: true,
        }) /* comment */
      )
    )
    .optional()
    .default({}),
  selectedVariants: z
    .array(
      z.object({
        setId: z.string(),
        variantId: z.string(),
      })
    )
    .optional(),
})

export type UserPreferences = z.infer<typeof userPreferencesSchema>
export type UserPreferencesUpdate = Update<UserPreferences>

export const userPreferencesBaseOps = generate(
  'user-preferences',
  userPreferencesSchema.parse
)
